import { defineComponent as _defineComponent } from 'vue'
import CamposDadosBasicos from './components/cadastro/CamposDadosBasicos.vue';
import CamposAlteracaoData from './components/cadastro/CamposAlteracaoData.vue';
import CamposEmenta from './components/cadastro/CamposEmenta.vue';
import ModalAlterarDatas from './components/cadastro/ModalAlterarDatas.vue';
import { onMounted, watch } from 'vue';
import { useCadastroParecerReferencialStore } from './store/CadastroParecerReferencialStore';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'CadastroParecerReferencial',
  setup(__props) {

const store = useCadastroParecerReferencialStore();
const router = useRouter();
const {
  isEditing,
  modalAlterarDatas,
  parecerReferencial,
  showModalConfirmacaoExcluirRenovacao,
} = storeToRefs(store);

onMounted(() => {
  store.$reset();
  store.popularTela();

  const params = new URLSearchParams(window.location.search);

  if (params.has('dadosCpa')) {
    store.parseDadosCPA(params.get('dadosCpa')!);
  } else if (router.currentRoute.params.cdParecerReferencial) {
    parecerReferencial.value.cdParecerReferencial = Number(
      router.currentRoute.params.cdParecerReferencial
    );
    store.buscar();
  }
});

watch(
  () => modalAlterarDatas.value.show,
  (value) => {
    if (value) {
      modalAlterarDatas.value.dtParecer = parecerReferencial.value.dtParecer;
      modalAlterarDatas.value.dtValidade = parecerReferencial.value.dtValidade;
    }
  }
);

return { __sfc: true,store, router, isEditing, modalAlterarDatas, parecerReferencial, showModalConfirmacaoExcluirRenovacao, CamposDadosBasicos, CamposAlteracaoData, CamposEmenta, ModalAlterarDatas }
}

})